import { useMemo } from 'preact/hooks';
import { FormFieldContextProps } from '../UNSAFE_useFormFieldContext';

type UseTextFieldProps = {
  hasTruncatedLabel?: boolean;
  hasValue?: boolean;
  isDisabled?: boolean;
  isFocused?: boolean;
  isInputFocused?: boolean;
  isLoading?: boolean;
  isReadonly?: boolean;
};

/**
 * A custom hook to determine props to set FormFieldContext
 */
export function useFormFieldContextProps({
  hasTruncatedLabel,
  hasValue,
  isDisabled,
  isFocused,
  isInputFocused,
  isLoading,
  isReadonly
}: UseTextFieldProps) {
  return useMemo<FormFieldContextProps>(() => {
    return isReadonly
      ? {
          hasTruncatedLabel,
          hasValue,
          isFocused,
          isInputFocused,
          isLoading,
          isReadonly: true
        }
      : isDisabled
      ? {
          hasTruncatedLabel: false,
          hasValue,
          isDisabled: true,
          isLoading
        }
      : {
          hasTruncatedLabel,
          hasValue,
          isFocused,
          isInputFocused,
          isLoading
        };
  }, [hasTruncatedLabel, hasValue, isDisabled, isFocused, isInputFocused, isLoading, isReadonly]);
}
